export enum CustomizeComponentEnum {
  KIOSK = 'KIOSK',
  MOBILE = 'MOBILE',
  MOBILE_V3 = 'MOBILE_V3',
  PASS_INFO = 'PASS_INFO',
  CONFIRMATION_EMAIL = 'CONFIRMATION_EMAIL',
}
